import {useId, useState} from 'react';
import {MathText} from './MathText';
import {checkChoiceHint, type ChoiceHintConfig} from './titration-labeling';
import './titration-labeling.css';

/** A formative choice inside an explicitly opened, tracked help level. */
export function ChoiceHint({config, number, disabled=false}: {
  config: ChoiceHintConfig;
  number: number;
  disabled?: boolean;
}) {
  const name = useId();
  const [selected, setSelected] = useState('');
  const [checked, setChecked] = useState(false);
  const correct = checked && checkChoiceHint(config, selected);
  return <fieldset className="choice-hint" disabled={disabled}>
    <legend>Aide {number} · À toi de choisir</legend>
    <p><MathText text={config.prompt}/></p>
    <div className="choice-hint-options">{config.options.map(option => <label key={option.id} className={selected===option.id?'is-selected':''}>
      <input type="radio" name={name} value={option.id} checked={selected===option.id}
        onChange={()=>{setSelected(option.id); setChecked(false);}}/>
      <MathText text={option.text}/>
    </label>)}</div>
    <button type="button" disabled={disabled||!selected} onClick={()=>setChecked(true)}>Vérifier mon choix</button>
    {checked && <p role="status" className={`choice-hint-feedback ${correct?'is-correct':'is-incorrect'}`}>
      <strong>{correct?'Oui, ce choix convient. ':'Reprends ce choix. '}</strong><MathText text={config.explanation}/>
    </p>}
  </fieldset>;
}
